import {
	FETCH_POINTS_INTERETS_BEGIN,
	FETCH_POINTS_INTERETS_ERROR,
	FETCH_POINTS_INTERETS_SUCCESS,
	POST_POINTS_INTERETS_BEGIN,
	POST_POINTS_INTERETS_ERROR,
	POST_POINTS_INTERETS_RESET,
	POST_POINTS_INTERETS_SUCCESS,
	DELETE_POINT_INTERET_BEGIN,
	DELETE_POINT_INTERET_ERROR,
	DELETE_POINT_INTERET_RESET,
	DELETE_POINT_INTERET_SUCCESS,
} from "../actions/pointInteretActions"

const initialState = {
	parcs: [],
	fourrieres: [],
	polices: [],
	ateliers: [],
	fetchPointsInterets: {
		loading: false,
		error: false,
	},
	postPointsInterets: {
		saving: false,
		saved: false,
		error: false,
	},
	deletePointInteret: {
		deleting: false,
		deleted: false,
		error: false,
	},
}

export default function pointInteretReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_POINTS_INTERETS_BEGIN:
			return {
				...state,
				fetchPointsInterets: {
					loading: true,
					error: false,
				},
			}
		case FETCH_POINTS_INTERETS_SUCCESS:
			return {
				...state,
				parcs: action.payload.parcs,
				fourrieres: action.payload.fourrieres,
				polices: action.payload.polices,
				ateliers: action.payload.ateliers || [],
				fetchPointsInterets: {
					loading: false,
					error: false,
				},
			}
		case FETCH_POINTS_INTERETS_ERROR:
			return {
				...state,
				fetchPointsInterets: {
					loading: false,
					error: action.payload || "Erreur inconnue",
				},
			}
		case POST_POINTS_INTERETS_BEGIN:
			return {
				...state,
				postPointsInterets: {
					saving: true,
					saved: false,
					error: false,
				},
			}
		case POST_POINTS_INTERETS_SUCCESS:
			return {
				...state,
				parcs: action.payload.parcs,
				fourrieres: action.payload.fourrieres,
				polices: action.payload.polices,
				ateliers: action.payload.ateliers || [],
				postPointsInterets: {
					saving: false,
					saved: true,
					error: false,
				},
			}
		case POST_POINTS_INTERETS_RESET:
			return {
				...state,
				postPointsInterets: {
					saving: false,
					saved: false,
					error: false,
				},
			}
		case POST_POINTS_INTERETS_ERROR:
			return {
				...state,
				postPointsInterets: {
					saving: false,
					saved: false,
					error: action.payload || "Erreur inconnue",
				},
			}
		case DELETE_POINT_INTERET_BEGIN:
			return {
				...state,
				deletePointInteret: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case DELETE_POINT_INTERET_SUCCESS:
			return {
				...state,
				parcs: action.payload.parcs,
				fourrieres: action.payload.fourrieres,
				polices: action.payload.polices,
				ateliers: action.payload.ateliers || [],
				deletePointInteret: {
					deleting: false,
					deleted: true,
					error: false,
				},
			}
		case DELETE_POINT_INTERET_RESET:
			return {
				...state,
				deletePointInteret: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case DELETE_POINT_INTERET_ERROR:
			return {
				...state,
				deletePointInteret: {
					deleting: false,
					deleted: false,
					error: action.payload || "Erreur inconnue",
				},
			}
		default:
			return state
	}
}
